export const PLANS = {
  FREE: 'free_user',
  BASIC: 'basic',
  ENTERPRISE: 'enterprise',
} as const;

export const PERMISSIONS = {
  SAVE_PROJECT: 'save_project',
  EXPORT_BOM: 'export_bom',
  EXPORT_PDF: 'export_pdf',
} as const;

export type PlanType = typeof PLANS[keyof typeof PLANS];
export type PermissionType = typeof PERMISSIONS[keyof typeof PERMISSIONS];
